import Button from 'react-bootstrap/Button';
import { FaUserPlus } from "react-icons/fa6";
import { Accordion, Card } from 'react-bootstrap';
import { FaUsersCog } from "react-icons/fa";
import NewUser from '../../components/Modals/Create/NewUser';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const UserAdministration = ({ titre }) => {

    const [showNewUser, setShowNewUser] = useState(false);
    const navigate = useNavigate();
    const { hasPermission } = useAuth();

    const handleClick = () => {
        navigate('/administration-groupe')
    }

    const handleShowNewUser = () => {
        setShowNewUser(true);
    }


    return (
        <>
            <div className="d-sm-flex align-items-center justify-content-between mb-4">
                <h1 className="h3 mb-0 text-gray-800">{titre}</h1>
                <div>
                    <Button variant="secondary" className=" btn-icon-split mr-2" onClick={handleClick}
                    >
                        <span className="icon text-white "><FaUsersCog size={20} /></span>
                        <span className="text">Gérer les groupes</span>
                    </Button>
                    {hasPermission('CREATE_USER') && (
                    <Button variant="warning" className=" btn-icon-split" onClick={handleShowNewUser}>
                        <span className="icon text-white "><FaUserPlus size={20} /></span>
                        <span className="text">Ajouter un utilisateur</span>
                    </Button>
                    )}
                </div>
            </div>

            <div className='row'>
                <div className='col-12'>
                    <Card className="border-left-utilisateur shadow mb-4">
                        <Accordion defaultActiveKey="0">
                            <Accordion.Item eventKey="1">
                                <Accordion.Header >
                                    <h6 style={{ color: "black" }} className='m-0 font-weight-bold text-body'>Liste des utilisateurs</h6>
                                </Accordion.Header>
                                <Accordion.Body>
                                    <p>Aucun utilisateur trouvé.</p>
                                </Accordion.Body>
                            </Accordion.Item>
                        </Accordion>
                    </Card>
                </div>
            </div>

            <NewUser showNewUser={showNewUser} setShowNewUser={setShowNewUser} />
        </>
    )
}

export default UserAdministration